/**
 * Constants for the B2B business subdomain that need to be available on BOTH
 * the server and the client. The matching `getHost()` / `isBusinessSubdomain()`
 * helpers stay in `request.server.ts` because they read `request.headers` and
 * branch on `process.env.NODE_ENV` — pure server concerns.
 *
 * The split is to avoid pulling the `.server.ts` module into the client
 * bundle: meta functions (`meta = ...`) run on the client too, and importing
 * a server-only file from a client-reachable code path leaves a broken
 * module reference that aborts React hydration.
 */
export const BUSINESS_HOST = 'business.archiproamerica.com';

export const BUSINESS_ORIGIN = `https://${BUSINESS_HOST}`;

/**
 * Origin to use in canonical / OG URLs for the B2B routes.
 *
 * The B2B pages currently render directly at
 * `https://www.archiproamerica.com/b2b/*` (the origin host guard is OFF — see
 * `app/routes/_app.b2b.tsx`). Until `business.archiproamerica.com` is wired
 * via edge rewrite or 302 redirect, canonicals must point at where the page
 * actually lives, or Google indexes a host that doesn't resolve.
 *
 * When the subdomain goes live, swap this back to `BUSINESS_ORIGIN`
 * and add `/brands` / `/professionals` to the route-side paths (drop the
 * `/b2b/` prefix) so canonicals match the public URLs.
 */
export const B2B_CANONICAL_ORIGIN = 'https://www.archiproamerica.com';
